import { useRef, useEffect, useState } from 'react';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';
import { v4 as uuidv4 } from 'uuid';
import { getRandomInt } from '../helpers/getRandomInt';

export const useCarousel = (allMessages, type) => {
  const {
    carousel,
    repeatCount,
    startFrom,
    duration,
    startFromWin,
    carouselWin,
  } = useGetParams();

  const carouselParam = type === 'winner' ? carouselWin : carousel;
  const startFromParam = type === 'winner' ? startFromWin : startFrom;
  const repeatCountParam = type === 'winner' ? 1 : repeatCount;

  let messages = allMessages.slice(-repeatCountParam);

  const [showedMessages, setShowedMessages] = useState([]);

  const nextMessageIndexRef = useRef(-1);
  const currentMessageRef = useRef(null);

  const iterateIndex = (array) => {
    if (carouselParam === '1') {
      if (!array.length) {
        nextMessageIndexRef.current = -1;
        return;
      }
      if (nextMessageIndexRef.current < array.length - 1) {
        nextMessageIndexRef.current++;
      } else {
        if (messages.length >= startFromParam) {
          nextMessageIndexRef.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRef.current < messages.length - 1)
        nextMessageIndexRef.current++;
      else {
        nextMessageIndexRef.current = messages.length - 1;
      }
    }
  };

  const updateShowedMessages = (newMessage) => {
    if (newMessage && messages.length >= startFromParam) {
      currentMessageRef.current = newMessage;
      const currentMessageWithUUID = {
        ...newMessage,
        UUID: uuidv4(),
        randomTranslateX: getRandomInt(-60, 60),
        randomTranslateY: getRandomInt(-250, -320),
        randomDuration: getRandomInt(15, 25),
        randomSize: getRandomInt(17, 23),
        randomLeft: getRandomInt(-30, 30),
      };

      const newMessagesArr = [currentMessageWithUUID, ...showedMessages].slice(
        0,
        10,
      );
      // const messagesIds = messages.map((message) => message.id);
      // const finallyMessagesArr = newMessagesArr.filter((message) =>
      //   messagesIds.includes(message.id),
      // );
      setShowedMessages(newMessagesArr);
    }
  };

  // useEffect(() => {
  //   // очищаем удаленные сообщения
  //   const messagesIds = messages.map((message) => message.id);
  //   const finallyMessagesArr = showedMessages.filter((message) =>
  //     messagesIds.includes(message.id),
  //   );
  //   if (finallyMessagesArr.length !== showedMessages.length) {
  //     setShowedMessages(finallyMessagesArr);
  //   }
  // }, [messages]);

  useEffect(() => {
    if (carouselParam === '1' && messages.length < startFromParam) {
      return;
    }
    if (messages && messages.length > 0) {
      iterateIndex(messages);
      updateShowedMessages(messages[nextMessageIndexRef.current]);
    }
  }, []);

  // Выбор сообщения для показа
  useInterval(() => {
    iterateIndex(messages);
    if (
      !messages[nextMessageIndexRef.current]?.id ||
      (showedMessages.some(
        (el) => el.id === messages[nextMessageIndexRef.current].id,
      ) &&
        carouselParam === '0')
    ) {
      return;
    } else if (carouselParam === '1' && messages.length < startFromParam) {
      return;
    } else {
      updateShowedMessages(messages[nextMessageIndexRef.current]);
    }
  }, duration);

  return {
    showedMessages,
  };
};
